import { getFactionWrestlerIds } from './factionWrestlers';

export const buildUserFactionWrestlerMap = (factions = []) => {
  const wrestlerMap = {};

  factions.forEach((faction) => {
    if (!faction) return;

    const factionName = faction.name || 'Fazione';
    const uniqueWrestlerIds = [...new Set(getFactionWrestlerIds(faction).filter(Boolean))];

    uniqueWrestlerIds.forEach((wrestlerId) => {
      if (!wrestlerMap[wrestlerId]) {
        wrestlerMap[wrestlerId] = {
          count: 0,
          factionIds: [],
          factionNames: [],
        };
      }

      wrestlerMap[wrestlerId].count += 1;
      wrestlerMap[wrestlerId].factionIds.push(faction.id);
      wrestlerMap[wrestlerId].factionNames.push(factionName);
    });
  });

  return wrestlerMap;
};
